export default {
  login: {
    title: 'Iniciar sesión en mypage',
    double_check_text: 'Datos incorrectos. Por favor confirme que haya ingresado los datos correctamente.',
    id_email: 'ID/correo electrónico',
    password: 'Contraseña',
    password_display: 'Mostrar contraseña',
    password_no_display: 'Ocultar contraseña',
    login: 'Inicio de sesión',
    keep_login_text: 'Mantener estado de conexión',
    forgot_password_text: 'Olvidé la contraseña',
    contact_us: 'Regístrese aquí',
    asuene_service_outline: '"ASUENE", servicio en la nube de visualización de CO2',
    // asuene_lca_service_outline: '',
    asuene_career_service_outline: 'Plataforma de contratación focalizada en el talento GX/ESG «ASUENE CAREER»',
    corporate_page: 'Sitio web corporativo',
    // cross_use: {
    //   title: '',
    //   asuene_product: {
    //     banner_title: '',
    //     flag_text: '',
    //     left_btn_label: '',
    //     left_btn_link: '',
    //     right_btn_label: '',
    //     right_btn_link: '',
    //   },
    //   footer_note: ''
    // }
  },
}
